import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../../services/content/content.service'
import { Models } from '@ibexfusion/models'

@Pipe({name: 'pinboard'})

export class PinboardPipe implements PipeTransform {
    constructor(private contentService: ContentService) {
    }

    transform(entry: Models.ContentEntry): Models.PinboardEntry | Models.PinboardEntry[] {
        if (!entry) {
            return null;
        }

        if (entry?.related?.entries?.length > 0) {
            const entries: Models.PinboardEntry[] = entry.related.entries.map(i =>
                this.transform(this.contentService.getEntry(i.id)) as Models.PinboardEntry)
                .filter(Boolean);
            return entries.length === 0 ? null : entries;
        }

        const pinboard = new Models.PinboardEntry();

        let documents = this.contentService.getDocumentEntriesForEntry(entry?.getId?.() || entry?._id);
        let media = this.contentService.getMediaEntriesForEntry(entry?.getId?.() || entry?._id);

        pinboard.populateFromJSON({
            title: entry.title,
            documents,
            media,
        });

        return pinboard;
    }
}

